import { CONFIG } from './config.js';
import { dom } from './dom.js';

export const Utils = {
  escapeRegex(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  },

  getType(value) {
    if (value === null) return 'null';
    if (Array.isArray(value)) return 'array';
    return typeof value;
  },

  isContainer(value) {
    const type = Utils.getType(value);
    return type === 'object' || type === 'array';
  },

  createSpan(className, text) {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    return span;
  },

  setStatusBadge(element, text, variant = '') {
    element.textContent = text;
    element.className = variant ? `badge ${variant}` : 'badge';
  },

  showToast(message) {
    dom.toast.textContent = message;
    dom.toast.classList.add('show');
    window.clearTimeout(Utils.showToast.timer);
    Utils.showToast.timer = window.setTimeout(() => {
      dom.toast.classList.remove('show');
    }, CONFIG.toastDuration);
  },
};
